import { createAnimation } from "@ionic/react";
import { ComponentProps, PropsWithChildren, useEffect, useState } from "react";

import Modal from "@components/Modal";

type Props = PropsWithChildren<
  Omit<ComponentProps<typeof Modal>, "children" | "className" | "enterAnimation" | "leaveAnimation">
>;

const OverlayModal = ({ children, opener, ...modalProps }: Props) => {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 576);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsSmallScreen(window.innerWidth <= 576);
    };

    window.addEventListener("resize", checkScreenSize);

    return () => {
      window.removeEventListener("resize", checkScreenSize);
    };
  }, []);

  const enterAnimation = (baseEl: HTMLElement) => {
    const root = baseEl.shadowRoot;

    const wrapperAnimation = createAnimation()
      .addElement(root?.querySelector(".modal-wrapper")!)
      .keyframes(
        isSmallScreen
          ? [
              { offset: 0, opacity: "1", transform: "translateY(100%)" },
              { offset: 1, opacity: "1", transform: "translateY(0)" }
            ]
          : [
              { offset: 0, opacity: "1", transform: "translateX(100%)" },
              { offset: 1, opacity: "1", transform: "translateX(0)" }
            ]
      );

    return createAnimation().addElement(baseEl).easing("ease-out").duration(250).addAnimation(wrapperAnimation);
  };

  const leaveAnimation = (baseEl: HTMLElement) => {
    const root = baseEl.shadowRoot;

    const wrapperAnimation = createAnimation()
      .addElement(root?.querySelector(".modal-wrapper")!)
      .keyframes(
        isSmallScreen
          ? [
              { offset: 0, opacity: "1", transform: "translateY(0)" },
              { offset: 1, opacity: "1", transform: "translateY(100%)" }
            ]
          : [
              { offset: 0, opacity: "1", transform: "translateX(0)" },
              { offset: 1, opacity: "1", transform: "translateX(100%)" }
            ]
      );

    return createAnimation().addElement(baseEl).easing("ease-in").duration(250).addAnimation(wrapperAnimation);
  };

  return (
    <Modal
      {...modalProps}
      backdropDismiss
      breakpoints={undefined}
      className="overlay"
      enterAnimation={enterAnimation}
      handleBehavior={undefined}
      hideHeader
      initialBreakpoint={undefined}
      leaveAnimation={leaveAnimation}
      opener={opener}
      showBackdrop={false}
    >
      {() => children}
    </Modal>
  );
};

export default OverlayModal;
